import { BaseController } from '../../../common/base/controller';

class SellFragmentsController extends BaseController {
  constructor(configService, controllerService, bankSourceService, $scope) {
    'ngInject';
    super({ configService, controllerService, bankSourceService, $scope });
  }

  get iconPath() {
    return this.configService.getFeature(this.Features.infoIconPath);
  }

  $onInit() {
    this.sellFragmentsOptions = {
      type: 'checkbox',
      iconPath: this.iconPath,
      infoTextKey: 'app.oldPortfolioState.sellFragments.info',
      label: 'app.oldPortfolioState.sellFragments',
      name: 'app.oldPortfolioState.sellFragments',
      model: 'sellFragments',
      checked: this.portfolio.sellFragments,
    };

    this.messages = {
      fragmentsProceedsDestinationIban: {
        required: 'app.required',
        iban: 'app.oldPortfolioState.error.invalidIban',
      },
      fragmentsProceedsDestinationBic: {
        required: 'app.required',
      },
      fragmentsProceedsDestinationBankName: {
        required: 'app.required',
      },
      fragmentsProceedsDestinationAccountOwner: {
        required: 'app.required',
      },
    };

    // Prevent initial watch trigger
    this.$timeout(() => (this.watchModelBindings = true));

    // fragmentsProceedsDestinationIban -> fill bank properties
    this.$scope.$watch(
      'vm.portfolio.fragmentsProceedsDestinationIban',
      (newValue) => {
        if (!this.watchModelBindings) return;
        this.fillBankProperties(newValue);
      },
    );
  }

  fillBankProperties(iban) {
    let destinationIban = this.form.fragmentsProceedsDestinationIban;
    if ((destinationIban && destinationIban.$invalid) || !iban) {
      return;
    }
    let legacyBankIdentifier = this.extractLegacyBankIdentifier(iban);
    this.bankSourceService
      .resourceSearch(legacyBankIdentifier)
      .then((response) => {
        let bank = response[0];
        this.portfolio.fragmentsProceedsDestinationBic = bank.BIC;
        this.portfolio.fragmentsProceedsDestinationBankName = bank.description;
      });
  }

  extractLegacyBankIdentifier(iban) {
    return iban.replace(/\s/g, '').slice(4, 12);
  }
}

export default SellFragmentsController;



// WEBPACK FOOTER //
// ./src/app/common/ui/sellFragments/sellFragments.controller.js